import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import OEMTroubleshootTable from '../../../../components/Tables/Montgomery/OEMTroubleshoot';
import { MMANavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';

const SITroubleshootOverview = () => {
	return (
		<>
			<Header plant="montgomery" />
			<main>
				<wrapper class="section-wrapper">
					<MMANavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/montgomery/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Troubleshooting</Breadcrumb.Item>
							<Breadcrumb.Item active>OEM Troubleshooting</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs defaultActiveKey="OEM Equipment Troubleshooting" className="mb-3">
								<Tab eventKey="OEM Equipment Troubleshooting" title="OEM Equipment Troubleshooting">
									<h2>OEM EQUIPMENT TROUBLESHOOTING</h2>

									<p>Troubleshooting information for the Original Equipment Manufacturer (OEM) can be found in the documentation provided by the equipment manufacturer. The following tables list the documents where the troubleshooting information can be found, as well as the section and page. </p>

									<OEMTroubleshootTable tablesorter={true} />
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SITroubleshootOverview;
